import type { ISODateString, UUID, Nullable } from './common';

export const RECURRING_INTERVALS = ['monthly', 'quarterly'] as const;
export type RecurringInterval = (typeof RECURRING_INTERVALS)[number];

export interface RecurringJobSchedule {
  id: UUID;
  sourceJobId: UUID;
  interval: RecurringInterval;
  startDate: ISODateString;   // YYYY-MM-DD
  nextDueAt: ISODateString;   // ISO timestamp
  lastFiredAt: Nullable<ISODateString>;
  createdAt: ISODateString;
  updatedAt: ISODateString;
}

export interface RecurringJobScheduleSummary extends RecurringJobSchedule {
  sourceJob: {
    id: UUID;
    jobCode: Nullable<string>;
    description: Nullable<string>;
    clientName: Nullable<string>;
  };
  isDue: boolean;
}

export type RecurringJobScheduleInput = {
  sourceJobId: UUID;
  interval: RecurringInterval;
  startDate: ISODateString;
};

export type RecurringJobScheduleUpdate = {
  interval?: RecurringInterval;
  startDate?: ISODateString;
};
